// extracted by mini-css-extract-plugin
export default {"lightBlue":"Box_lightBlue__VSLK9","light":"Box_light__rUGKT"};